'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _glamor = require('glamor');

var _components = require('components');

var _applications = require('redux/modules/applications');

var _Table = require('@quixeltools/quixel-ui-library/dist/components/common/website/Table');

var _Table2 = _interopRequireDefault(_Table);

var _Hr = require('@quixeltools/quixel-ui-library/dist/components/common/website/Hr');

var _Hr2 = _interopRequireDefault(_Hr);

var _Button = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/Button');

var _Button2 = _interopRequireDefault(_Button);

var _TextButton = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton');

var _TextButton2 = _interopRequireDefault(_TextButton);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _polyfluid = require('@quixeltools/quixel-ui-library/dist/utils/polyfluid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tableSection = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  marginTop: {
    smallMedium: 2.578,
    large: [2.578, 3.4375]
  }
}));

var title = (0, _glamor.css)({
  color: _css.colors.white,
  fontWeight: 300
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  },
  marginBottom: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  }
}));

var table = (0, _glamor.css)({
  '& th:nth-child(1)': { width: '25%' },
  '& th:nth-child(2)': { width: '50%' },
  '& th:nth-child(3)': { width: '25%' },

  '& tbody': {
    color: _css.colors.white,
    fontSize: {
      smallMedium: 1,
      large: [1, 1.125]
    }
  }
});

var UserAuthorisedApplications = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(UserAuthorisedApplications, _React$Component);

  function UserAuthorisedApplications(props) {
    (0, _classCallCheck3.default)(this, UserAuthorisedApplications);
    return (0, _possibleConstructorReturn3.default)(this, (UserAuthorisedApplications.__proto__ || (0, _getPrototypeOf2.default)(UserAuthorisedApplications)).call(this, props));
  }

  (0, _createClass3.default)(UserAuthorisedApplications, [{
    key: 'onRevokeClick',
    value: function onRevokeClick(app) {
      var _this2 = this;

      this.context.dialogs.prompt('Would you like to revoke access from following developer app?\n\n' + app.application.name + '?').then(function (res) {
        if (res) {
          _this2.props.dispatch((0, _applications.revokeApplication)(app.id));
        }
      });
    }
  }, {
    key: 'renderApplications',
    value: function renderApplications() {
      var _this3 = this;

      var styles = require('./UserAuthorisedApplications.scss');
      var applications = this.props.applications;


      return _react2.default.createElement(
        'table',
        { className: styles['table'] + ' ' + styles['table-striped'] },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              null,
              '\xA0'
            ),
            _react2.default.createElement(
              'th',
              null,
              'App ID'
            ),
            _react2.default.createElement(
              'th',
              null,
              'App Name'
            ),
            _react2.default.createElement(
              'th',
              null,
              '\xA0'
            )
          )
        ),
        _react2.default.createElement(
          'colgroup',
          null,
          _react2.default.createElement('col', { style: { width: '8.33%' } }),
          _react2.default.createElement('col', { style: { width: '44.44%' } }),
          _react2.default.createElement('col', { style: { width: '22.22%' } }),
          _react2.default.createElement('col', { style: { width: '25%' } })
        ),
        _react2.default.createElement(
          'tbody',
          null,
          applications.map(function (app) {
            return _react2.default.createElement(
              'tr',
              { key: app.id },
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement('img', { style: { width: 20, height: 20 }, src: app.application.icon })
              ),
              _react2.default.createElement(
                'td',
                { className: styles.id },
                app.id
              ),
              _react2.default.createElement(
                'td',
                null,
                app.application.name
              ),
              _react2.default.createElement(
                'td',
                { style: { float: 'right' } },
                _react2.default.createElement(_Button2.default, { small: true, label: 'Revoke', onClick: function onClick(e) {
                    e.preventDefault();_this3.onRevokeClick(app);
                  } })
              )
            );
          })
        )
      );
    }
  }, {
    key: 'renderApp',
    value: function renderApp() {
      var _this4 = this;

      var applications = this.props.applications;


      var entries = applications.map(function (app) {
        return [_react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { src: app.application.icon, className: (0, _glamor.css)({ display: 'inline-block', verticalAlign: 'middle', width: 24, height: 24 }) }),
          _react2.default.createElement(
            'span',
            { className: (0, _glamor.css)({ display: 'inline-block', verticalAlign: 'middle', paddingLeft: 16 }) },
            app.application.name
          )
        ), _react2.default.createElement(
          'span',
          { className: (0, _glamor.css)({ verticalAlign: 'middle' }) },
          app.id
        ), _react2.default.createElement(_TextButton2.default, { className: (0, _glamor.css)({ display: 'inline-block', verticalAlign: 'middle', color: _css.colors.red, padding: '0 0 ' + (0, _css.unitRem)(0.0835) + ' 0' }), mode: 'small-underlined', label: 'Revoke Access', onClick: function onClick(e) {
            e.preventDefault();_this4.onRevokeClick(app);
          } })];
      });

      return _react2.default.createElement(_Table2.default, {
        className: table,
        columnTitles: ['App Name', 'App ID', 'Access'],
        columnWidths: ['25%', '50%', '25%'],
        entries: entries
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./UserAuthorisedApplications.scss');
      var _props = this.props,
          loading = _props.loading,
          loaded = _props.loaded,
          applications = _props.applications,
          loadingError = _props.loadingError;


      return _react2.default.createElement(
        'section',
        { className: tableSection },
        _react2.default.createElement(
          'h1',
          { className: title },
          'Authorised Apps'
        ),
        loaded && applications.length !== 0 && this.renderApp(),
        loaded && applications.length === 0 && _react2.default.createElement(
          'div',
          { style: { color: _css.colors.gray, margin: (0, _css.unitRem)(2) + ' 0' } },
          _react2.default.createElement(
            'p',
            null,
            'You have not connected any apps yet.'
          )
        ),
        loaded && applications.length !== 0 && _react2.default.createElement(_Hr2.default, { className: (0, _glamor.css)({ margin: (0, _css.unitRem)(2) + ' 0' }) }),
        loading && _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', marginTop: '2em' } },
          _react2.default.createElement(_components.LoadingIndicator, null)
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _glamor.css)({ color: _css.colors.gray }) },
          _react2.default.createElement(
            'p',
            { style: { margin: '1em 0', lineHeight: '1.5' } },
            'Authorized applications are any third-party applications that leverage your Megascans account and have requested login from you.'
          ),
          _react2.default.createElement(
            'p',
            { style: { margin: '1em 0', lineHeight: '1.5' } },
            'You can revoke access to any of the applications if you no longer want to use the associated third-party application.'
          )
        )
      );
    }
  }]);
  return UserAuthorisedApplications;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
var UserAuthorisedApplicationsContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loading: state.applications.authorizedApplications.loading,
    loaded: state.applications.authorizedApplications.loaded,
    loadingError: state.applications.authorizedApplications.loadingError,
    applications: state.applications.authorizedApplications.applications
  };
}), _dec(_class2 = function (_React$Component2) {
  (0, _inherits3.default)(UserAuthorisedApplicationsContainer, _React$Component2);

  function UserAuthorisedApplicationsContainer() {
    (0, _classCallCheck3.default)(this, UserAuthorisedApplicationsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (UserAuthorisedApplicationsContainer.__proto__ || (0, _getPrototypeOf2.default)(UserAuthorisedApplicationsContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserAuthorisedApplicationsContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _applications.loadAuthorisedApplications)());
    }
  }, {
    key: 'render',
    value: function render() {
      var dispatch = this.props.dispatch;


      return _react2.default.createElement(UserAuthorisedApplications, this.props);
    }
  }]);
  return UserAuthorisedApplicationsContainer;
}(_react2.default.Component)) || _class2);
exports.default = UserAuthorisedApplicationsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthorisedApplications/UserAuthorisedApplications.jsx
// module id = 2734
// module chunks = 0